const state = {
	favoriteCasinoGames: localStorage.getItem("favorite-casino-games")
		? JSON.parse(localStorage.getItem("favorite-casino-games"))
		: [],
};

const persistFavorites = (favorites) => {
	localStorage.setItem("favorite-casino-games", JSON.stringify(favorites));
};

const getters = {
	favoriteGames: (state) => {
		return state.favoriteCasinoGames ? state.favoriteCasinoGames : [];
	},
};

const actions = {
	addToFavorites({ commit }, payload) {
		commit("setCasinoFavorites", payload);
	},
};

const mutations = {
	setCasinoFavorites(state, favorite) {
		let favorites = state.favoriteCasinoGames;
		console.log("Favorites from payload: ", favorite);
		let exists =
			favorites.findIndex((game) => game.gameID == favorite.gameID) > -1;

		if (exists) {
			state.favoriteCasinoGames = state.favoriteCasinoGames.filter(function (
				game
			) {
				return game.gameID != favorite.gameID;
			});
		} else {
			state.favoriteCasinoGames.push(favorite);
		}

		console.log("Favorites: ", state.favoriteCasinoGames);
		persistFavorites(state.favoriteCasinoGames);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
